export const handleCostBooking = (hour: number, costFee: number, minimumSessionFee:number ) => {
  const sumCosts = costFee * hour;
  if(sumCosts < minimumSessionFee){
    return minimumSessionFee
  }
  return sumCosts;
};

export default handleCostBooking;
